export default __webpack_public_path__ + "static/media/Notif - Program Fee.5e880216.svg";